var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgTagsIcon = function SvgTagsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.575.951L1.151 2.012.09 9.437l6.893 6.894a.75.75 0 001.06 0l7.426-7.425a.75.75 0 000-1.06L8.575.95zm-.53 1.592l5.834 5.833-6.364 6.364L1.68 8.906l.795-5.568 5.569-.795zm-1.59 4.773a1.5 1.5 0 10-2.123-2.122 1.5 1.5 0 002.123 2.122z",
    fill: "#666"
  })));
};
export default SvgTagsIcon;